import { useEffect } from 'react';
import { allNotificationDeliveries } from '../queries';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';

export function useAllNotificationDeliveries (top, offset, setIsEndOfList) {
  const { data: query , refetch: refresh, loading: isLoading } = useQuery(allNotificationDeliveries, {
    fetchPolicy: 'no-cache',
    variables: { top, offset },
  });

  useEffect(() => {
    if (query?.allNotificationDeliveries?.edges.length < top) {
      setIsEndOfList(true);
    }
  }, [query, top, setIsEndOfList]);

  const prepare = (query?.allNotificationDeliveries?.edges.length) > 0 ? removeConnectionsMemoized(query?.allNotificationDeliveries) : [];

  const data = prepare.map(item => {
    const investment = JSON.parse(item.investment);
    if (investment && investment.length > 0) {
      const recipient = item.recipient ?? item.email;
      const recipientName = (item.recipientName&&item.recipientName.length > 0) ? item.recipientName : item.email;
      return {...item, investment: investment[0].id, program: investment[0].program, recipient, recipientName };
    }
  });

  return {
    data,
    refresh,
    isLoading
  };
}
